import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.6 4.8c0-1.9 1.5-3.4 3.4-3.4h10.8c1.9 0 3.4 1.5 3.4 3.4v6.6a1 1 0 1 1-2 0V4.8c0-.8-.6-1.4-1.4-1.4H6c-.8 0-1.4.6-1.4 1.4v14.4c0 .8.6 1.4 1.4 1.4h4.8a1 1 0 1 1 0 2H6a3.4 3.4 0 0 1-3.4-3.4V4.8Z"
    />
    <path d="M14 18.5c0-.6.4-1 1-1h3.6l-.8-.8a1 1 0 0 1 1.5-1.4l2.4 2.4c.4.4.4 1 0 1.5l-2.3 2.3a1 1 0 1 1-1.4-1.4l.6-.6H15a1 1 0 0 1-1-1Z" />
  </>,
  'CopyTo'
)
